export const STORE_KEY = {
  USER_INFO: 'userInfo',
  IS_DEBUG: 'isDebug',
  ENV_SELECT: 'envSelect',
  PACKAGE_PATH: 'packagePath',
  USER_ACCOUNT: 'userAccount',
  USER_PASSWORD: 'userPassword',
};
